import { Component, ElementRef, OnDestroy, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { SelectPartComponent } from 'src/app/core/dialogs/select-part/select-part.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PpfService } from 'src/app/services/ppf/ppf.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { GridOptions } from 'ag-grid-community';
import { column1, column2, column3 } from './ppfConsts.const';
import { ExportStateService } from 'src/app/services/export-state.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
;
;;

import { PpfCellRenderer } from 'src/app/core/gridrender/ppf-cell-render';
import { PPFInputCellRendererComponent } from 'src/app/core/gridrender/ppf-input-cellRenderer';
import { GlobalStateService } from 'src/app/services/service/global-state.service';
import { ConstantsService } from 'src/app/services/constant.service';
import { PpfServiceInternal } from 'src/app/internal-vpacs/services-internal/ppf.service';
@Component({
  selector: 'app-ppf',
  templateUrl: './ppf.component.html',
  styleUrls: ['./ppf.component.scss']
})
export class PpfComponent implements OnInit,OnDestroy {
  @ViewChild('PPF') PPF!: ElementRef;
  protected openModal = false;
  public gridApi: any;
  public rowHeight = 40;
  public defaultColDef = {};
  public columnDefs: any[] = [];
  public columnDefs2: any[] = [];
  public domLayout: any = '';
  public displayRowData: any;
  public displayRowData2: any[] = [];
  public readOnly = false;
  public editFlagOne = false;
  public editFlagTwo = false;
  public metaData: any = {};
  public ppfData: any;
  public image: any[] = []
  public gridOptions: GridOptions = {}
  public gridOptions2: GridOptions = {}
  public customGridOptions: GridOptions[] = [];
  protected isMazda = false;
  public editMode = 0;
  public viewMode = 0;
  public ERR_ARR: any[] = [];
  ppfForm = this.formbuilder.group(
    {
      hazmat: [''],
      broadcastPart: [''],
    }
  )
  ppfPassData: any;
  imageNames: any[] = [];
  response: any;
  PPFCODE: any = ''
  public ISUPDATEPPF = 3;
  step09status: any;
  formatError: any[] = [];
  weightArray: any;
  contW: any = 0;
  dun1W: any = 0;
  dun2W: any = 0;
  topW: any = 0;
  pltW: any = 0;
  constPartNumber: any;
  originalPart: {
    PARTL: any;
    PARTW: any;
    PARTH: any;
    PARTWEIGHT: any;
    QTYPARTCONTRACK: any;
    SUPINVENTORYREQ: any;
    SUPINVENTORYALLO: any;
  } | undefined;
  newPackageInfo: any;
  topHeight: any;
  checkSuporFab: any;
  visibility = false;
  flexStart = 'flex-start';
  imgData: any = [];
  retVal: any;
  previousUrl = '';
  specialCharError:any = [];
  userinfo: any;
  userInfoSubscriber: any;

  constructor(
    public _location: Location,
    private readonly dialog: MatDialog,
    public router: ActivatedRoute,
    private readonly ppfService: PpfService,
    public sanitizer: DomSanitizer,
    public formbuilder: FormBuilder,
    public state: ExportStateService,
    public route: Router,
    public globalState: GlobalStateService,
    private readonly constants:ConstantsService,
    public internalPpfService: PpfServiceInternal,
  ) {
    if (this.router.snapshot.params['readOnly'] === 'readOnly') {
      this.readOnly = true;
    }
    this.defaultColDef = {
      suppressMovable: true,
      wrapText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      suppressHorizontalScroll: true,
      enableCellTextSelection: true,
    }
  }

  ngOnInit(): void {
    this.getUserInfo();
    this.checkSuporFab = sessionStorage.getItem('checkSupFab');
    if (this.checkSuporFab === '1') {
      this.visibility = true;
    }
    else {
      this.visibility = false;
    }
    this.previousUrl = this.globalState.getPreviousURL();
    if(this.previousUrl.includes('/new-package')){
      this.newPackageInfo = this.globalState.getNewPackagePPF();
    }else{
      this.globalState.resetNewPackagePPF();
      this.globalState.resetgrid1();
      this.globalState.resetgrid2();
      this.globalState.hazmat = null;
      this.globalState.imgData = [];
      this.globalState.imgNum = [];
    }   
    if (!this.readOnly) {
      this.ppfPassData = JSON.parse(sessionStorage.getItem("ppfPassData") ?? '');
    }
    if (sessionStorage.hasOwnProperty('PPFqueryParams') && this.readOnly) {
      this.metaData = JSON.parse(sessionStorage.getItem('PPFqueryParams') ?? '');
      this.PPFCODE = this.metaData?.ppfNumber;
      this.step09status = Number(this.metaData.STEP09STATUS);
      this.ISUPDATEPPF = [4, 5].includes(this.step09status) ? 2 : (this.metaData?.ISUPDATEPPF || 2);
      if (this.metaData.supplierCode.indexOf("J") === 0) {
        this.isMazda = true
      }
    }
    if (sessionStorage.hasOwnProperty("ppfPassData") && !this.readOnly) {

      this.ppfPassData = JSON.parse(sessionStorage.getItem("ppfPassData") ?? '');
      this.PPFCODE = this.ppfPassData.ppfNumber
      if (this.ppfPassData.supplierCode.indexOf("J") === 0) {
        this.isMazda = true
      }
      if (this.ppfPassData?.ISUPDATEPPF && this.ppfPassData?.ISUPDATEPPF !== 0) {
        this.ISUPDATEPPF = this.ppfPassData?.view;
      }
      this.editMode = this.ppfPassData?.edit ? this.ppfPassData?.edit : 0;
      this.viewMode = this.ppfPassData?.view ? this.ppfPassData?.view : 0;

      if ((this.viewMode === 1 && this.editMode === 1)) {
        this.editFlagOne = true;
      }
      else if ((this.viewMode === 1 && this.editMode === 2)) {
        this.editFlagTwo = true;
      }
      else if ((this.viewMode === 2 && this.editMode === 0)) {
        this.readOnly = true;
      }
    }

    this.getUserInfo();
    this.PPFCODE && this.ppfService.ppfOnLoad(this.PPFCODE, this.ISUPDATEPPF).subscribe({
      next: (res: any) => {
        if (res.result !== 'No Data Found') {
          this.response = res;
          this.constPartNumber = res?.ppfData?.PARTNUMBER
          this.ppfData = res.ppfData;
          if (res.status) {
            this.ppfData['FABCODE'] = this.nullUndefinedConverterString(res.status.FABCODE);
            this.ppfData['DUN1FABCODE'] = this.nullUndefinedConverterString(res.status.DUN1FABCODE);
            this.ppfData['STEP08STATUS'] = this.nullUndefinedConverterString(res.status.STEP08STATUS);
          }
          this.weightArray = res?.weightArray.map((x: any) => x ? parseFloat(x) : 0);
          this.contW = this.weightArray[1];
          this.dun1W = this.weightArray[2];
          this.dun2W = this.weightArray[3];
          this.topW = this.weightArray[4];
          this.pltW = this.weightArray[5];
          this.topHeight = res.topHeight;
          this.imageNames = [res.ppfData?.PICPART, res.ppfData?.PICDUNNAGE, res.ppfData?.PICCONTRACK, res.ppfData?.PICPALLET];
          for (let index = 0; index < 4; index++) {
            this.imageNames[index] && this.getOnLoadImages(index);
          }
          // retaining images
          const imgNum = this.globalState.getImgNum();
          const imgData = this.globalState.getImgData()
          for (let i = 0; i < imgNum?.length; i++) {
            this.image[imgNum[i] - 1] = imgData[i];
          }
          //end
          this.originalPart = {
            PARTL: res?.ppfData?.PARTL,
            PARTW: res?.ppfData?.PARTW,
            PARTH: res?.ppfData?.PARTH,
            PARTWEIGHT: res?.ppfData?.PARTWEIGHT,
            QTYPARTCONTRACK: res?.ppfData.QTYPARTCONTRACK,
            SUPINVENTORYREQ: res?.ppfData.SUPINVENTORYREQ,
            SUPINVENTORYALLO: res?.ppfData.SUPINVENTORYALLO,
          }
          //retaining grid1 & grid 2 data
          let arr: any = [];
          if (this.globalState.getGrid1Data()?.length > 0) {
            arr = this.globalState.getGrid1Data()
            this.retVal = this.globalState.getNewPackagePPF()
            for (let i = 0; i < arr.length; i++) {
              if (this.retVal && (i === (Number(this.retVal?.rowNumber) - 1))) {
                arr[i].COST = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.COSTLABEL);
                arr[i].DESCRIPTION = this.nullUndefinedConverterString(this.retVal?.data?.pkgCodeDetail?.DESCRIPTION);
                arr[i].PKGCODE = this.nullUndefinedConverterString(this.retVal?.data?.pkgCodeDetail?.PACKAGECODE);
                arr[i].MATERIAL = this.nullUndefinedConverterString(this.retVal?.data?.pkgCodeDetail?.MATERIAL);
                arr[i].LEADTIME = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.LEADTIME);
                arr[i].RETEXP = this.nullUndefinedConverterString(this.retVal?.data?.pkgCodeDetail?.RETURNABLE);
              }
            }
            switch (Number(this.retVal?.rowNumber)) {
              case 1:
                this.contW = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                this.weightArray[1] = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                break;
              case 2:
                this.dun1W = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                this.weightArray[2] = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                break;
              case 3:
                this.dun2W = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                this.weightArray[3] = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                break;
              case 4:
                this.topW = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                this.weightArray[4] = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                this.topHeight = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.OUTERHEIGHT);
                break;
              case 5:
                this.pltW = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                this.weightArray[5] = this.nullUndefinedConverter(this.retVal?.data?.pkgCodeDetail?.WEIGHT);
                break;
 
              default:
                break;
            }
            const data = arr;
            this.displayRowData = data;
            this.gridOptions.rowData = data;
            this.globalState.resetgrid1();
          } else {
            const data = this.gridOne(res);
            this.displayRowData = data;
            this.gridOptions.rowData = data;
          }
          if (this.globalState.getGrid2Data()) {
            const data = this.globalState.getGrid2Data();
            this.displayRowData2 = data;
            this.gridOptions2.rowData = data;
            this.globalState.resetgrid2();
 
          } else {
            const data = this.gridTwo({ ...res, PALLETLOADH: res.palletLoadH });
            this.displayRowData2 = data;
            this.gridOptions2.rowData = data;
            this.weightCalculation();
          }
          //end
          this.setValues(res.ppfData);
          if (this.globalState.getNewPackagePPF()) {
            this.setValuesOnChangeOfPkg({ ...this.retVal?.data?.pkgCodeDetail, row: Number(this.retVal?.rowNumber) - 1 })
          }
        }
      },
      error: (_error: any) => {
        this.displayRowData = [];
        this.displayRowData2 = []
      },
    });
    this.columnDefs = this.getGrid1ColumnDefs();
    this.columnDefs2 = this.getGrid2ColumnDefs();
    this.customGridOptions = [
      { columnDefs: [...this.columnDefs] },
      {
        columnDefs: [...this.columnDefs2],
      },
    ];
    this.gridOptions = {
      columnDefs: [...this.columnDefs]
    }
    this.gridOptions.enableCellTextSelection=true

    this.gridOptions2 = {
      columnDefs: [...this.columnDefs2]
    }
  }


  getUserInfo() {
    this.userInfoSubscriber = this.state.userInfoState.subscribe({
      next: (res: any) => {
        if (Array.isArray(res.info)) {
          this.userinfo = res?.info[0];
        }
      }
    });
  }

  nullUndefinedConverterString(data: any) {
    if ([null, undefined, 'null', 'undefined'].includes(data)) {
      return '';
    }
    return data;
  }

  getOnLoadImages(imageNumber: number) {
    const payload = {
      ppfcode: this.PPFCODE,
      viewmode: this.ISUPDATEPPF,
      imageNumber: imageNumber
    }
    this.PPFCODE && this.ppfService.ppfImageOnLoad(payload).subscribe({
      next: (res: any) => {
        if (res && res.data !== 'No Image') {
          const data = res.data;
          if (data) {
            const image = this.sanitizer.sanitize(SecurityContext.URL, `data:image/jpg;base64,${data}`);
            this.image[imageNumber] = image;
          } else {
            this.image[imageNumber] = null;
          }
        } else {
          this.image[imageNumber] = null;
        }
      },
      error: (_err: any) => {
      }
    })
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDomLayout("autoHeight");
  }
  sizeToFit() { this.gridApi?.sizeColumnsToFit() }

  navigatePrevious() {
    this._location.back();
  }

  weightCalculation() {
    let grid2: any = [];
    let grid1: any = [];
    this.gridOptions2.rowData?.forEach((x: any) => {
      grid2.push(x)
    })
    this.gridOptions.rowData?.forEach((x: any) => {
      grid1.push(x)
    });    
    grid1 = grid1.map((obj: any) => ({ ...obj, QUANTITY: Number(obj?.QUANTITY) }));
    grid2 = grid2.map((obj: any) => ({ ...obj, WEIGHT: Number(obj.WEIGHT), QUANTITIES2: Number(obj.QUANTITIES2) }));
    const dunWeight = (Number(this.dun1W) * Number(grid1[1]?.QUANTITY)) + (Number(this.dun2W) * Number(grid1[2]?.QUANTITY));
    const contgrossweigth = Number(this.contW) + dunWeight + (Number(grid2[0].WEIGHT) * Number(grid2[0].QUANTITIES2));
    const mcl = Number(grid2[1].QUANTITIES2);
    const mlp = Number(grid2[2].QUANTITIES2);
    if (mcl === 0 || mlp === 0) {
      grid1[3].QUANTITY = 0;
      grid1[4].QUANTITY = 0;
    } else {
      grid1[3].QUANTITY = Number((1 / (mcl * mlp)).toFixed(3));
      grid1[4].QUANTITY = Number((1 / (mcl * mlp)).toFixed(3));
    }
    this.displayRowData = grid1;
    this.gridOptions.rowData = this.displayRowData;
    const palletloadweight = (contgrossweigth * mcl * mlp) + (this.pltW + this.topW);
    grid2[1].WEIGHT = dunWeight ? dunWeight.toFixed(3) : 0;
    grid2[2].WEIGHT = this.contW ? Number(this.contW).toFixed(3) : 0;
    grid2[4].WEIGHT = contgrossweigth ? Number(contgrossweigth).toFixed(3) : 0;
    grid2[5].WEIGHT = palletloadweight ? Number(palletloadweight).toFixed(3) : 0;
    this.displayRowData2 = grid2;
    this.gridOptions2.rowData = this.displayRowData2;
    this.calculatePalletLoadH(grid1, grid2);
  }

  row1DynamicValue(data: any, newData: any) {
    data[1].LENGTH = Number(newData?.OUTERLENGTH)  || 0;
    data[1].WIDTH = Number(newData?.OUTERWIDTH) || 0;
    data[1].HEIGHT = Number(newData?.OUTERHEIGHT) || 0;
    data[2].LENGTH = Number(newData?.INNERLENGTH) || 0;
    data[2].WIDTH = Number(newData?.INNERWIDTH) || 0;
    data[2].HEIGHT = Number(newData?.INNERHEIGHT) || 0;
    this.contW = Number(newData?.WEIGHT) || 0;
    this.weightArray[1] = Number(newData?.WEIGHT) || 0;
    data[3].HEIGHT = Number(newData?.RETHEIGHT) || 0;
    data[1].QUANTITIES2 = Number(newData?.QTYCONTLAYER) || 0;
    data[2].QUANTITIES2 = Number(newData?.QTYLAYERPALLET) || 0;
    data[3].QUANTITIES2 = Number(newData?.QTYKHOLDER) || 0;

    const grid1: any = [];
    this.gridOptions.rowData?.forEach((x: any) => {
      grid1.push(x)
    })
    this.displayRowData = grid1;
    this.displayRowData2 = data;
    this.gridOptions2.rowData = this.displayRowData2;
    this.weightCalculation();
  }

  row2DynamicValue(_grid1: any, _grid2: any, newData: any) {
    this.dun1W = Number(newData?.WEIGHT);
    this.weightArray[2] = Number(newData?.WEIGHT);
    this.weightCalculation();
  }

  row4DynamicValue(_grid: any, grid2: any, newData: any) {
    grid2[4].LENGTH = Number(newData?.OUTERLENGTH);
    grid2[4].WIDTH = Number(newData?.OUTERWIDTH);
    grid2[4].HEIGHT = Number(newData?.OUTERHEIGHT);
    grid2[5].LENGTH = Number(newData?.OUTERLENGTH);
    grid2[5].WIDTH = Number(newData?.OUTERWIDTH);
    grid2[5].HEIGHT = Number(newData?.OUTERHEIGHT);
    grid2[3].WEIGHT = Number(newData?.WEIGHT);
    this.pltW = Number(newData?.WEIGHT)
    this.weightArray[5] = Number(newData?.WEIGHT);
    this.displayRowData2 = grid2;
    this.gridOptions2.rowData = this.displayRowData2;
    this.weightCalculation();
  }

  setValuesOnChangeOfPkg(data: any) {
    const grid2: any = [];
    const grid1: any = [];
    this.gridOptions2.rowData?.forEach((x: any) => {
      grid2.push(x)
    })
    this.gridOptions.rowData?.forEach((x: any) => {
      grid1.push(x)
    })
    switch (data?.row) {
      case 0:
        this.row1DynamicValue(grid2, data);
        break;
      case 1:
        this.row2DynamicValue(grid1, grid2, data);
        break;
      case 2:
        this.dun2W = Number(data?.WEIGHT);
        this.weightArray[3] = Number(data?.WEIGHT);
        this.weightCalculation();
        break;
      case 3:
        this.topHeight = Number(data?.OUTERHEIGHT);
        this.topW = Number(data?.WEIGHT);
        this.weightArray[4] = Number(data?.WEIGHT);
        this.weightCalculation();
        break;
      case 4:
      this.row4DynamicValue(grid1, grid2, data)
        break;
      default:
        break;
    }
  }


  calculatePalletLoadH(_grid1: any, grid2: any) {
    const gridData = grid2;
    gridData[5].HEIGHT = (grid2[1].HEIGHT * grid2[2].QUANTITIES2) + grid2[4].HEIGHT + this.topHeight;
    this.displayRowData2 = gridData;
    this.gridOptions2.rowData = this.displayRowData2;
  }

  getGrid1ColumnDefs() {
    return [
      {
        headerName: 'Component Name', field: 'COMPONENT', maxWidth: 240, minWidth: 170,
        cellStyle: (_params: any) => {
          return { display: 'flex', 'justify-content': this.flexStart, height: '40px', padding: '0 10px', };
        },
      },
      { headerName: 'Description', field: 'DESCRIPTION', maxWidth: 240, minWidth: 120, },
      {
        headerName: 'Manufacturer', field: 'MANUFACTURER', maxWidth: 240, minWidth: 170, cellRendererFramework: PpfCellRenderer,
        cellRendererParams: {
          change: (_value: any) => {
            this.gridApi.redrawRows()
          },
        },
      },
      { headerName: 'Material', field: 'MATERIAL', maxWidth: 200, minWidth: 130, },
      {
        headerName: 'Package Code', field: 'PACKAGECODE', maxWidth: 320, minWidth: 200, cellRendererFramework: PpfCellRenderer,
        cellRendererParams: {
          ppf: this.ppfData,
          changed: (value: any) => {
            this.gridApi.redrawRows()
            this.setValuesOnChangeOfPkg(value)
          },
        },
      },
      { headerName: 'Lead Time', field: 'LEADTIME', maxWidth: 150, minWidth: 80, },
      { headerName: 'RET/ EXP', field: 'RETEXP', maxWidth: 100, minWidth: 60, },
      {
        headerName: 'QUANTITY/ CONT/ RACK', field: 'QUANTITY', maxWidth: 170, minWidth: 100, cellRendererFramework: PPFInputCellRendererComponent,
        cellRendererParams: {
          calculate: () => this.weightCalculation(),
        },
      },
      { headerName: 'Cost Estimate', field: 'COST', maxWidth: 180, minWidth: 80, cellRendererFramework: PPFInputCellRendererComponent, hide: this.visibility },
      {
        headerName: 'COMMENTS', field: 'COMMENTS', maxWidth: 300, minWidth: 150, cellRendererFramework: PPFInputCellRendererComponent,
        cellStyle: (_params: any) => {
          return {
            'white-space': 'break-spaces', 'word-break': 'break-word', 'line-height': '20px',
            display: 'flex', 'justify-content': this.flexStart, height: '40px', padding: '0 10px',
          };
        },
      },
    ];
  }

  getGrid2ColumnDefs() {
    return [
      {
        headerName: 'Component',
        field: 'COMPONENT',
        maxWidth: 240,
        minWidth: 200,
        cellStyle: (_params: any) => {
          return {
            display: 'flex',
            'justify-content': this.flexStart,
            height: '40px',
            padding: '0 10px',
          };
        },
      },
      {
        headerName: 'LENGTH(mm)',
        field: 'LENGTH',
        maxWidth: 240,
        minWidth: 60,
        cellRendererFramework: PPFInputCellRendererComponent,
      },
      {
        headerName: 'WIDTH(mm)',
        field: 'WIDTH',
        maxWidth: 200,
        minWidth: 60,
        cellRendererFramework: PPFInputCellRendererComponent,
      },
      {
        headerName: 'HEIGHT(mm)',
        field: 'HEIGHT',
        maxWidth: 200,
        minWidth: 60,
        cellRendererFramework: PPFInputCellRendererComponent,
        cellStyle: (_params: any) => {
          return { 'border-right': '2px solid #E4ECF0' };
        },
      },
      {
        headerName: 'Component',
        field: 'COMPONENT2',
        maxWidth: 360,
        minWidth: 250,
        cellStyle: (_params: any) => {
          return {
            display: 'flex',
            'justify-content': this.flexStart,
            height: '40px',
            padding: '0 10px',
          };
        },
      },
      {
        headerName: 'Weight(kg)',
        field: 'WEIGHT',
        maxWidth: 200,
        minWidth: 80,
        cellRendererFramework: PPFInputCellRendererComponent,
        cellRendererParams: {
          calculate: () => this.weightCalculation(),
        },
        cellStyle: (_params: any) => {
          return { 'border-right': '2px solid #E4ECF0' };
        },
      },
      {
        headerName: 'Quantities',
        field: 'QUANTITIES',
        minWidth: 250,
        tooltipValueGetter: (params: any) => params.value,
        cellStyle: (params: any) => {
          if (params.value === 'SUPPLIER INVENTORY') {
            return {
              background: '#E4ECF0',
              display: 'flex',
              'justify-content': 'center',
            };
          }
          return {
            'white-space': 'break-spaces',
            'word-break': 'break-word',
            'line-height': '20px',
            display: 'flex',
            'justify-content': this.flexStart,
            height: '40px',
            padding: '0 10px',
          };
        },
        colSpan: (params: any) => {
          return params.data.row === 4 ? 2 : 1;
        },
        wrapText: true,
      },
      {
        headerName: '',
        field: 'QUANTITIES2',
        maxWidth: 100,
        minWidth: 60,
        cellRendererFramework: PPFInputCellRendererComponent,
        cellRendererParams: {
          calculate: () => this.weightCalculation(),
        },
      },
    ];
  }

  setValues(data: any) {
    //retaining hazmat
    if (this.globalState.getHazmat()) {
      this.ppfForm?.controls.hazmat.setValue(this.globalState.getHazmat() || "N")
    } else {
      this.ppfForm?.controls.hazmat.setValue(data.HAZMAT || "N");
      this.ppfForm.get('hazmat')?.valueChanges.subscribe(value => {
        this.globalState.setHazmat(value);
      });
    }
    this.ppfForm?.controls?.broadcastPart.setValue(data.BROADCASTFLAG === 1 ? 'Y' : 'N');
    if (this.readOnly) {
      this.ppfForm?.get('hazmat')?.disable();
    }
  }

  selectPart() {
    const dialogData = this.dialog.open(SelectPartComponent, { width: '100%', data: { supplierCode: this.ppfPassData?.supplierCode, partWeight: this.ppfData?.PARTWEIGHT } });
    dialogData.afterClosed().subscribe((result: any) => {
      if (result) {
        const gridOne = result.data?.dppfwork;
        const gridTwo = result.data.selectData[0];
        if (this.response.manufacts[0]) {
          gridOne.manufacts[0] = this.response.manufacts[0];
        }        
        this.displayRowData = this.gridOne({
          manufacts: gridOne?.manufacts, pkgcodes: gridOne?.PkgCode, descriptions: gridOne?.Description, materials: gridOne?.Material,
          leadtimes: gridOne?.LeadTime, retexps: gridOne?.RetExp, qtycontracks: gridOne?.QtyContRack, costestimates: result.data.array.manufacturer?.costEstimate, comments: gridOne?.comments
        });        
        this.gridOptions.rowData = this.displayRowData;

        this.weightArray = result.data?.array.weightArray.map((x: any) => x ? parseFloat(x) : 0);
        this.contW = this.weightArray[1];
        this.dun1W = this.weightArray[2];
        this.dun2W = this.weightArray[3];
        this.topW = this.weightArray[5];
        this.pltW = this.weightArray[4];

        const capitalCaseOne = Object.keys(gridOne).reduce((accumulator: any, key) => {
          accumulator[key.toUpperCase()] = gridOne[key];
          return accumulator;
        }, {});
        this.displayRowData2 = this.gridTwo({
          ppfData: {
            ...capitalCaseOne,
            SUPINVENTORYREQ: this.originalPart?.SUPINVENTORYREQ,
            SUPINVENTORYALLO: this.originalPart?.SUPINVENTORYALLO,
            PARTL: this.originalPart?.PARTL,
            PARTW: this.originalPart?.PARTW,
            PARTH: this.originalPart?.PARTH,
            PARTWEIGHT: this.originalPart?.PARTWEIGHT,
            PALLETLOADH: gridTwo?.PALLETLOADH,
            PALLETWEIGHT: gridTwo?.PALLETWEIGHT,
            DUNNAGEWEIGHT: gridTwo?.DUNNAGEWEIGHT,
            QTYPARTCONTRACK: gridTwo?.QTYPARTCONTRACK
          },
          weightArray : result.data?.dppfwork?.weightArray,
          qtycontracks : result.data?.dppfwork?.QtyContRack
        });
        this.gridOptions2.rowData = this.displayRowData2;
        this.weightCalculation();
        this.imageNames = [result.data.selectData[0]?.PICPART, result.data.selectData[0]?.PICDUNNAGE, result.data.selectData[0]?.PICCONTRACK, result.data.selectData[0]?.PICPALLET]
        const firstImage = this.image[0];
        const images: any[] = [
          result.data.image.images[0],
          result.data.image.images[1],
          result.data.image.images[2],
          result.data.image.images[3]
        ]
        this.image = [];
        for (let index = 0; index < 4; index++) {
          if (result.data.image.images.length > 0 && result.data.image.images?.result !== 'No Image' && this.imageNames[index]) {
            // api calls individual
            const body = {
              "PPFCode": this.PPFCODE,
              "PPFVer": "-1",
              "pType": index + 1,
              "File": {
                "FileName": this.imageNames[index],
                "Data": images[index].data
              }
            };
            this.internalPpfService.uploadImage(body).subscribe({
              next: (_res: any) => {
                if (_res.status) {
                  const data = images[index].data;
                  const image = this.sanitizer.sanitize(SecurityContext.URL, `data:image/jpg;base64,${data}`);
                  this.image.push(image)
                }
              },
              error: (_err: any) => {
                this.specialCharError = [_err?.error];
              }
            });
          } else {
            this.image.push(null)
          }
        }
        this.image[0] = firstImage || null;
      }
    })
  }

  removeStringNull(input: any[]) {
    input = input.map((ip: any) => {
      return [null, undefined, "null"].includes(ip) ? 0 : Number(ip)
    })
    return input;
  }

  //changes
  removeStringNull1(input: any[], input1: any[]) {
    return input?.map((value, index) => {
      if (value === 0 && input1[index] !== null) {
        return input1[index];
      } else {
        return value;
      }
    });
  }
  nullUndefinedConverter(data: any) {
    if ([null, undefined, 'null', 'undefined'].includes(data)) {
      return 0;
    }
    return Number(data);
  }
  gridOne(res: any) {
    const ids = [1, 2, 3, 4, 5, 6, 7, 8];
    const component = ['CONTAINER', 'DUNNAGE 1', 'DUNNAGE 2', 'TOP CAP', 'PALLET', 'STRETCH WRAP/STRAP', 'KANBAN CARD HOLDER', 'OTHER']
    const { manufacts, pkgcodes, descriptions, materials, leadtimes, retexps, qtycontracks, comments } = res;
    const costestimates: any = this.removeStringNull1(res.costestimates, res.manufacturerCost?.costEstimate)
    const items: any = ids.map((id, index) => {
      return {
        row: id,
        COMPONENT: component[index],
        MANUFACTURER: manufacts[index] ? manufacts[index] : '',
        MATERIAL: materials[index] ? materials[index] : '',
        DESCRIPTION: descriptions[index] ? descriptions[index] : '',
        PKGCODE: pkgcodes[index] ? pkgcodes[index] : '',
        LEADTIME: leadtimes[index] ? leadtimes[index] : '',
        RETEXP: retexps[index] ? retexps[index] : '',
        QUANTITY: qtycontracks[index] ? parseFloat(qtycontracks[index]).toFixed(3) : 0,
        COST: costestimates[index],
        COMMENTS: comments[index] ? comments[index] : '',
        SUPPLIERCODE: this.ppfPassData?.supplierCode ? this.ppfPassData.supplierCode : this.metaData?.supplierCode,
        EDITMODE: (!this.readOnly) ? this.nullUndefinedConverter(this.ppfPassData.edit) : this.nullUndefinedConverter(this.metaData?.edit),
        VIEWMODE: (!this.readOnly) ? this.nullUndefinedConverter(this.ppfPassData.view) : this.nullUndefinedConverter(this.metaData?.view),
        ppfData: this.ppfData
      };
    });
    if (this.globalState.getNewPackagePPF()) {
      const data = this.globalState.getNewPackagePPF();
      const rowIndex = items.findIndex((obj: any) => obj.row === parseInt(data.rowNumber));
      if (rowIndex !== -1) {
        items[rowIndex].COST = parseFloat(data.data?.pkgCodeDetail?.COSTLABEL || 0);
        items[rowIndex].DESCRIPTION = data.data?.pkgCodeDetail?.DESCRIPTION;
        items[rowIndex].PKGCODE = data.data?.pkgCodeDetail?.PACKAGECODE;
        items[rowIndex].MATERIAL = data.data?.pkgCodeDetail?.MATERIAL;
        items[rowIndex].LEADTIME = data.data?.pkgCodeDetail?.LEADTIME;
        items[rowIndex].RETEXP = data.data?.pkgCodeDetail?.RETURNABLE;
      }
      return items;
    } else {
      return items;
    }
  }

  gridTwo(res: any) {
    const { PARTL, CONTL, INCONTL, PALLETONLYL, PALLETLOADL,
      PARTW, CONTW, INCONTW, PALLETONLYW, PALLETLOADW,
      PARTH, CONTH, INCONTH, PALLETONLYH, CONTRETH,
      PARTWEIGHT, CONTRACKWEIGHT, PALLETWEIGHT, CONTRACKGROSSWEIGHT, PALLETLOADGROSSWEIGHT,
      QTYPARTCONTRACK, QTYMAXCONTLAYER, QTYMAXLAYERPALLET, SUPINVENTORYREQ, SUPINVENTORYALLO } = res.ppfData;
    const DUNNAGEWEIGHT = (Number(res.weightArray[2]) * Number(res.qtycontracks[1])) + (Number(res.weightArray[3]) * Number(res.qtycontracks[2]));
    const ids = [1, 2, 3, 4, 5, 6];
    const component = column1;
    const component2: any[] = column2
    const quantities: any[] = column3
    const length = [PARTL, CONTL, INCONTL, '', PALLETONLYL, PALLETLOADL].map((x: any) => x ? parseFloat(x) : 0);
    const width = [PARTW, CONTW, INCONTW, '', PALLETONLYW, PALLETLOADW].map((x: any) => x ? parseFloat(x) : 0);;
    const height = [PARTH, CONTH, INCONTH, CONTRETH, PALLETONLYH, res?.palletLoadH].map((x: any) => x ? parseFloat(x) : 0);;
    const weight2 = [PARTWEIGHT, DUNNAGEWEIGHT, CONTRACKWEIGHT, PALLETWEIGHT, CONTRACKGROSSWEIGHT, PALLETLOADGROSSWEIGHT].map((x: any) => x ? parseFloat(x) : 0);
    const quantities2 = [QTYPARTCONTRACK, QTYMAXCONTLAYER, QTYMAXLAYERPALLET, 0, SUPINVENTORYREQ, SUPINVENTORYALLO].map((x: any) => x ? parseFloat(x) : 0);
    const qty2 = quantities2.map((value: any) => value ? parseFloat(value).toFixed(3) : 0).map(Number)
    const weight = weight2.map((value: any) => value ? Number(value).toFixed(3) : 0);
    const wht = weight.map(Number);
    const items: any = ids.map((id, index) => {
      return {
        row: id,
        COMPONENT: component[index],
        COMPONENT2: component2[index],
        QUANTITIES: quantities[index],
        QUANTITIES2: qty2[index],
        LENGTH: length[index],
        WIDTH: width[index],
        HEIGHT: height[index],
        WEIGHT: wht[index],
        EDITMODE: this.ppfPassData?.edit ? this.ppfPassData.edit : this.metaData?.view,
        VIEWMODE: this.ppfPassData?.view ? this.ppfPassData.view : this.metaData?.view,
        SUPORFAB: this.visibility
      }
    });
    return items;
  }


  handleUpload(event: any, imageNumber: any) {
    const file = event.target.files[0];
    const reader:any = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      if (imageNumber) {
        //get file type
        const prefix = 'data:image/';
        const base64Image: any = reader.result
        const base64Parts = base64Image?.split(';base64');
        const contentType = base64Parts[0].substring(prefix.length)
        //get file size
        const fileSizeInBytes = base64Image.length * 0.75;
        const fileSizeInKb = fileSizeInBytes / 1024;
        this.formatError[imageNumber - 1] = ''

        if (['jpeg', 'jpg', 'gif'].includes(contentType)) {
          if (fileSizeInKb < 200) {
            if (file.name !== undefined && file.name !== null) {
              const checkCharacters = this.constants.checkFilenameHasMoreThanFifyChars(file.name)
              if(checkCharacters.length > 0){
                this.specialCharError = checkCharacters;
                return;
              }else{
                this.specialCharError = [];
              }
              // api calls individual
              const body = {
                "PPFCode": this.PPFCODE,
                "PPFVer": "-1",
                "pType": imageNumber,
                "File": {
                  "FileName": file.name,
                  "Data": reader.result.split(',')[1]
                }
              };
              this.internalPpfService.uploadImage(body).subscribe({
                next: (_res: any) => {
                  if (_res.status) {
                    this.imageNames[imageNumber - 1] = file.name;
                    this.image[imageNumber - 1] = this.sanitizer.sanitize(SecurityContext.URL, `${reader.result}`);
                    //retaining images
                    this.imgData = this.sanitizer.sanitize(SecurityContext.URL, `${reader.result}`)
                    this.globalState.setImgNum(imageNumber)
                    this.globalState.setImgData(this.imgData)
                  }
                },
                error: (_err: any) => {
                  this.specialCharError = [_err?.error];
                }
              });
            }
          } else {
            this.formatError[imageNumber - 1] = 'Image size should be less than 200kb'
          }
        } else {
          this.formatError[imageNumber - 1] = 'Image should be of Jpg or Gif format'
        }
      }
    };
    reader.onerror = () => { alert('Error while uploading') }
  }

  handleDelete(imageNumber: number) {
    this.imageNames[imageNumber - 1] = ""
    this.image[imageNumber - 1] = ""
  }

  async printPPF() {
    if (this.ppfData) {
      const docDefinition: any = await this.createPdf();
      pdfMake.createPdf(docDefinition).open();
    }
  }

  savePPF() {
    const manufacts: any = [], pkgcode: any = [], descriptions: any = [], materials: any = [], leadtimes: any = [];
    const retexps: any = [], qtycontracks: any = [], costestimates: any = [], comments: any = [], images: any = []
    const grid2: any[] = []; let guid: any;
    const user = {
      fullname: this.visibility ? this.response?.ppfData?.SUPPLIERCONTACT : this.userinfo?.FULLNAME,
      phone: this.visibility ? this.response?.ppfData?.SUPPLIERPHONENUMBER : this.userinfo?.PHONE,
      fax: this.visibility ? this.response?.ppfData?.SUPPLIERFAXNUMBER : this.userinfo?.FAX,
      email: this.visibility ? this.response?.ppfData?.SUPPLIERMAIL : this.userinfo?.EMAIL
    }
    if (localStorage.getItem('toyotaGUID')) {
      guid = JSON.parse(localStorage.getItem('toyotaGUID') ?? '');
    }
    this.gridOptions2.rowData?.forEach((x: any) => {
      grid2.push(x)
    })
    const ppfData: any = {
      final: 1,
      picpart: this.imageNames[0] ? this.imageNames[0] : null,
      picdunn: this.imageNames[1] ? this.imageNames[1] : null,
      piccont: this.imageNames[2] ? this.imageNames[2] : null,
      picpall: this.imageNames[3] ? this.imageNames[3] : null,
      hazmat: this.ppfForm.controls.hazmat?.value || "N",
      partl: grid2[0].LENGTH,
      partw: grid2[0].WIDTH,
      parth: grid2[0].HEIGHT,
      contl: grid2[1].LENGTH,
      contw: grid2[1].WIDTH,
      conth: grid2[1].HEIGHT,
      incontl: grid2[2].LENGTH,
      incontw: grid2[2].WIDTH,
      inconth: grid2[2].HEIGHT,
      contreth: grid2[3].HEIGHT,
      palletonlyl: grid2[4].LENGTH,
      palletonlyw: grid2[4].WIDTH,
      palletonlyh: grid2[4].HEIGHT,
      palletloadl: grid2[5].LENGTH,
      palletloadw: grid2[5].WIDTH,
      palletloadh: grid2[5].HEIGHT,
      partweight: grid2[0].WEIGHT,
      dunnageweight: parseFloat(grid2[1].WEIGHT).toFixed(2),
      contrackweight: parseFloat(grid2[2].WEIGHT).toFixed(2),
      palletweight: parseFloat(grid2[3].WEIGHT).toFixed(2),
      contrackgrossweight: parseFloat(grid2[4].WEIGHT).toFixed(2),
      palletloadgrossweight: parseFloat(grid2[5].WEIGHT).toFixed(2),
      qtypartcontrack: grid2[0].QUANTITIES2,
      qtymaxcontlayer: grid2[1].QUANTITIES2,
      qtymaxlayerpallet: grid2[2].QUANTITIES2,
      reasonwhatcode: this.ppfPassData?.reasonwhat,
      reasonwhycode: this.ppfPassData?.reasonwhy,
      reasonwhat: this.ppfPassData?.reasonwhatcomment,
      reasonwhy: this.ppfPassData?.reasonwhycomment,
      supplierpsd: this.ppfPassData?.pkgstartdate,
      broadcastflag: this.ppfForm.controls.broadcastPart.value === 'Y' ? 1 : 0,
      supinventoryreq: grid2[4]?.QUANTITIES2,
      supinventoryallo: grid2[5]?.QUANTITIES2 || "0",
      saveFrom : !!((this.ppfPassData?.reasonwhat || this.ppfPassData?.reasonwhy))
    }

    this.gridOptions.rowData?.forEach((x: any) => {
      manufacts?.push(x.MANUFACTURER ? x.MANUFACTURER : '');
      descriptions?.push(x.DESCRIPTION ? x?.DESCRIPTION : '')
      materials?.push(x.MATERIAL ? x?.MATERIAL : '')
      pkgcode?.push(x.PKGCODE ? x?.PKGCODE : '')
      leadtimes?.push(x.LEADTIME ? x?.LEADTIME : '')
      retexps?.push(x.RETEXP ? x?.RETEXP : '')
      qtycontracks?.push(x.QUANTITY ? x.QUANTITY : 0)
      costestimates?.push(x.COST ? x?.COST : 0)
      comments?.push(x.COMMENTS ? x?.COMMENTS : '')
    })

    for (const element of this.image) {
      if (!element) {
        images.push('')
      } else {
        images.push(element?.split(',')[1]);
      }
    }
    const body: any = {
      supplierCode: this.ppfPassData?.supplierCode ?? this.metaData?.supplierCode, ppfData: ppfData, materials: materials, manufacts: manufacts,
      pkgcodes: pkgcode, descriptions: descriptions, comments: comments,
      leadtimes: leadtimes, retexps: retexps, qtycontracks: qtycontracks,
      costestimates: costestimates, user: user, guid: guid, suporfab: !this.visibility ? true : false
    }
    let ERR = false;
    const ERR_ARR: any[] = [];
    const component = ['CONTAINER', 'DUNNAGE 1', 'DUNNAGE 2', 'TOP CAP', 'PALLET', 'STRETCH WRAP/STRAP', 'KANBAN CARD HOLDER', 'OTHER']

    if (this.editMode === 0 || this.editMode === 2) {
      if (!pkgcode[0]) {
        ERR = true;
        ERR_ARR.push('Container package code is mandatory')
      }

      if ((pkgcode[1] && pkgcode[2]) && pkgcode[1] === pkgcode[2]) {
        ERR = true;
        ERR_ARR.push('Dunnage1 & Dunnage2 package codes should not be equal')
      }

      for (let i = 0; i < qtycontracks.length; i++) {
        if (isNaN(qtycontracks[i])) {
          ERR = true;
          ERR_ARR.push(component[i] + '- quantity must be a number')
        }
      }

      for (let i = 0; i < costestimates.length; i++) {
        if (isNaN(costestimates[i])) {
          ERR = true;
          ERR_ARR.push(component[i] + '- cost must be a number');
        }
      }

      if (this.response?.finalFlag === '1') {
        if (pkgcode[0] && !manufacts[0]) {
          ERR = true;
          ERR_ARR.push('Container manufacturer is required');
        }
        if (pkgcode[3] && !manufacts[3]) {
          ERR = true;
          ERR_ARR.push('Topcap manufacturer is required');
        }
        if (pkgcode[4] && !manufacts[4]) {
          ERR = true;
          ERR_ARR.push('Pallet manufacturer is required');
        }
      }

      if (pkgcode[1] && !qtycontracks[1]) {
        ERR = true;
        ERR_ARR.push('Dunnage1 quantity is required');
      }

      if (pkgcode[2] && !qtycontracks[2]) {
        ERR = true;
        ERR_ARR.push('Dunnage2 quantity is required');
      }

    }

    if (this.editMode === 0 || this.editMode === 1) {
      if (!grid2[0].LENGTH || isNaN(grid2[0].LENGTH) || grid2[0].LENGTH <= 0 || grid2[0].LENGTH > 9999) {
        ERR = true;
        ERR_ARR.push('PART length is required & should be greater than 0 and less than 9999')
      }
      if (!grid2[0].WIDTH || isNaN(grid2[0].WIDTH) || grid2[0].WIDTH <= 0 || grid2[0].WIDTH > 9999) {
        ERR = true;
        ERR_ARR.push('PART width is required & should be greater than 0 and less than 9999')
      }
      if (!grid2[0].HEIGHT || isNaN(grid2[0].HEIGHT) || grid2[0].HEIGHT <= 0 || grid2[0].HEIGHT > 9999) {
        ERR = true;
        ERR_ARR.push('PART height is required & should be greater than 0 and less than 9999')
      }
      if (!grid2[0].WEIGHT || isNaN(grid2[0].WEIGHT) || grid2[0].WEIGHT <= 0 || grid2[0].WEIGHT > 9999) {
        ERR = true;
        ERR_ARR.push('PART weight is required & should be greater than 0 and less than 9999')
      }
      if (!grid2[4]?.QUANTITIES2 || isNaN(grid2[4]?.QUANTITIES2) || grid2[4]?.QUANTITIES2 <= 0) {
        ERR = true;
        ERR_ARR.push('SUPPLIER INTERNAL INVENTORY REQUIREMENT (DAYS) is required & should be greater than 0')
      }

      if (!images[0]) {
        ERR = true;
        ERR_ARR.push('Part Image is required');
      }
    }

    if (this.editMode === 2) {
      if (this.response?.finalFlag === '1') {
        if (!images[2]) {
          ERR = true;
          ERR_ARR.push('Container Image is required');
        }
      }

      if (!grid2[0]?.QUANTITIES2 || isNaN(grid2[0]?.QUANTITIES2) || grid2[0]?.QUANTITIES2 <= 0) {
        ERR = true;
        ERR_ARR.push('QUANTITY PARTS/CONTAINER/RACK is required & should be greater than 0')
      }
    }

    if (this.editMode === 0) {
      if (this.response?.finalFlag === '1') {
        if (!images[2]) {
          ERR = true;
          ERR_ARR.push('Container Image is required');
        }
      }
      if (!grid2[0]?.QUANTITIES2 || isNaN(grid2[0]?.QUANTITIES2) || grid2[0]?.QUANTITIES2 <= 0) {
        ERR = true;
        ERR_ARR.push('QUANTITY PARTS/CONTAINER/RACK is required & should be greater than 0')
      }
      if (!grid2[1]?.QUANTITIES2 || isNaN(grid2[1]?.QUANTITIES2) || grid2[1]?.QUANTITIES2 <= 0) {
        ERR = true;
        ERR_ARR.push('MAXIMUM CONTAINER/LAYER ON PALLET is required & should be greater than 0')
      }
      if (!grid2[2]?.QUANTITIES2 || isNaN(grid2[2]?.QUANTITIES2) || grid2[2]?.QUANTITIES2 <= 0) {
        ERR = true;
        ERR_ARR.push('MAXIMUM LAYERS/PALLET is required & should be greater than 0')
      }
    }
    const columns = ['Container comment', 'Dunnage1 Comment', 'Dunnage2 Comment', 'Top cap comment','Pallet comment', 'Stretch Comment','Kanban comment','Other comment']
    const specialChars = this.constants.findSpecialCharsExternal(body,columns);
    if (ERR) {
      this.ERR_ARR = ERR_ARR;
      this.openModal = true;
    } else {
      if(specialChars.length){
        this.specialCharError = specialChars;
        return;
      }
      this.specialCharError = [];
      this.ppfService.sendPPF(body, this.ppfPassData?.ppfNumber ?? this.metaData?.ppfNumber, this.viewMode).subscribe({
        next: (_res) => {
          sessionStorage.setItem('ppfSaveData', JSON.stringify({ PPFCODE: this.PPFCODE }))
          this._location.back();
        },
        error: (_error) => {
        },
      })
    }

  }


  saveImageApi(){
    const images = [];
    for (const element of this.image) {
      if (!element) {
        images.push('')
      } else {
        images.push(element?.split(',')[1]);
      }
    }
    const payload = {images : images}
    this.ppfService.saveImagePPF(payload, this.ppfPassData.ppfNumber, this.viewMode).subscribe({
      next: (_res) => {
        sessionStorage.setItem('ppfSaveData', JSON.stringify({ PPFCODE: this.PPFCODE }))
        this._location.back();
      },
      error: (_error) => {
      },
    })
  }

  getBase64ImageFromURL(url: string) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx!.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }

  getDateFormat(date: string) {
    const dateArray = date.split('-');
    return `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
  }

  converNull(value: any) {
    if ([null, undefined, 'null', 'undefined'].includes(value)) {
      return ''
    }
    return value;
  }

  async createPdf() {
    const ppfData = this.ppfData;
    const response = this.response;
    const grid1: any[] = []
    const grid2: any[] = []
    let image: any[] = []
    this.gridOptions.rowData?.forEach((i: any) => {
      grid1.push(Object.fromEntries(Object.entries(i).map(([key, value]) => [key, value === null ? '' : value])))
    })
    this.gridOptions2.rowData?.forEach((x: any) => {
      grid2.push(Object.fromEntries(Object.entries(x).map(([key, value]) => [key, value === null ? '' : value])))
    })
    for (let i = 0; i < 4; i++) {
      if (this.image[i]) {
        image.push(this.image[i]);
      } else {
        image.push('data:image/png;base64,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')
      }
    }
    const regex = /data:image\/jpg/g;
    image = image.map((x: any) => x.replace(regex, 'data:image/png'))
    image = await Promise.all(
      Object.assign(
        [],
        image.map(async (x) => await this.getBase64ImageFromURL(x))
      )
    ).then((img) => img);
    return {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [10, 10, 10, 10],
      content: [
        {
          margin: [0, 10, 0, 0],
          style: 'table1',
          table: {
            widths: [70, 80, 90, 70, 70, 70, 70, 70, '*'],
            body: [
              [{ text: this.isMazda ? 'Mazda' : 'Toyota', colSpan: 2, rowSpan: 2, style: 'header1', alignment: 'center' }, '', { text: ppfData?.PLANTNAME, alignment: 'center', style: 'header1', colSpan: 2, rowSpan: 2 }, '', { text: 'PACKAGING PROPOSAL', alignment: 'center', colSpan: 3, style: 'header2' }, '', '', { text: 'PARTNUMBER', style: 'blue', rowSpan: 2 }, { text: 'PRELIMINARY OR FINAL', style: 'blue', rowSpan: 2 }],
              ['', '', '', '', { text: 'TOYOTA Engineering Manufacturing America', colSpan: 3, alignment: 'center' }, '', '', '', ''],
              ['SUPPLIERNAME', ppfData?.SUPPLIERNAME, 'PACKAGING CONATCT', ppfData?.SUPPLIERCONTACT, 'MODELNUMBER', { text: response?.modelCodes || ppfData?.MODELCODE, colSpan: 2 }, '', { text: this.constPartNumber, rowSpan: 4, style: 'part' }, `${ppfData?.PREORFINAL === 1 ? 'PRELIMINARY' : 'FINAL'}`],
              ['SUPPLIERCODE', ppfData?.SUPPLIERCODE, 'PHONENUMBER', ppfData?.SUPPLIERPHONENUMBER, 'PARTS DESCRIPTION', { text: ppfData?.PARTDESCRIPTION, colSpan: 2 }, '', '', `DATE : ${ppfData.REGDATE ? this.getDateFormat(new Date(ppfData.REGDATE).toISOString().slice(0, 10)) : ''}`],
              ['SUPPLIER PICKUP LOCATION', ppfData?.SUPPLIERPICKUP, 'FAXNUMBER', ppfData?.SUPPLIERFAXNUMBER, 'REPLACES PART DESCRIPTION', { text: ppfData?.REPLACESPARTNUMBER, colSpan: 2 }, '', '', `DOCKCODE : ${ppfData?.DOCKCODE}`],
              ['TLMS CODE', ppfData?.TLMS_CODE, 'EMAIL ADDRESS', ppfData?.SUPPLIERMAIL, 'ECI NUMBER', { text: ppfData?.ECINUMBER, colSpan: 2 }, '', '', `BROADCAST PART : ${this.ppfForm.controls.broadcastPart.value}`],
            ],
          },
        },
        {
          style: 'table1',
          layout: {
            hLineWidth: function (i: any, _node: any) {
              return (i === 0) ? 0 : 1;
            }
          },
          table: {
            widths: [4, 65, '*', 93, '*', 150, '*', '*', '*', '*'],
            body: [
              [{ text: 'DIGITAL IMAGE', rowSpan: 3, style: 'yellow' }, { text: 'PART ( IN PACKAGING DIRECTION)', colSpan: 2, style: 'blue' }, '', { text: 'DUNNAGE ( IN CONT/RACK USE DIRECTION)', colSpan: 2, style: 'blue' }, '', { text: 'CONT/RACK (INCLUDE KANBAN LOCATION)', colSpan: 2, style: 'blue' }, '', { text: 'PART ( IN PACKAGING DIRECTION)', colSpan: 3, style: 'blue' }, '', ''],
              ['', { image: image[0], colSpan: 2, width: 130, height: 130 }, '', { image: image[1], colSpan: 2, width: 130, height: 130 }, '', { image: image[2], colSpan: 2, width: 130, height: 130, }, '', { image: image[3], colSpan: 3, width: 130, height: 130 }, '', ''],
              ['', { text: `Hazmat : ${this.ppfForm.controls.hazmat.value}`, colSpan: 2, style: 'yellow' }, '', { text: '', colSpan: 7 }, '', '', '', '', '', ''],
            ]
          },
        },
        {
          margin: [0, 10, 0, 0],
          style: 'table1',
          table: {
            widths: [4, '*', '*', 70, 100, '*', 30, 30, 40, 40, '*'],
            body: [
              [{ text: 'PACKAGE MATERIAL', rowSpan: 9, style: 'yellow' }, { text: 'COMPONENT NAME', style: 'blue' }, { text: 'DESCRIPTION', style: 'blue' }, { text: 'MANUFACTURER', style: 'blue' }, { text: 'MATERIAL', style: 'blue' }, { text: 'PACKAGE CODE', style: 'blue' }, { text: 'LEAD TIME', style: 'blue' }, { text: 'RET/EXP', style: 'blue' }, { text: 'QUANTITY / CONT / Rack', style: 'blue' }, { text: 'COST ESTIMATES', style: 'blue' }, { text: 'COMMENTS', style: 'blue' }],
              ['', grid1[0]?.COMPONENT, grid1[0]?.DESCRIPTION, grid1[0]?.MANUFACTURER, grid1[0]?.MATERIAL, grid1[0]?.PKGCODE, grid1[0]?.LEADTIME, grid1[0]?.RETEXP, grid1[0]?.QUANTITY, grid1[0]?.COST, grid1[0]?.COMMENTS],
              ['', grid1[1]?.COMPONENT, grid1[1]?.DESCRIPTION, grid1[1]?.MANUFACTURER, grid1[1]?.MATERIAL, grid1[1]?.PKGCODE, grid1[1]?.LEADTIME, grid1[1]?.RETEXP, grid1[1]?.QUANTITY, grid1[1]?.COST, grid1[1]?.COMMENTS],
              ['', grid1[2]?.COMPONENT, grid1[2]?.DESCRIPTION, grid1[2]?.MANUFACTURER, grid1[2]?.MATERIAL, grid1[2]?.PKGCODE, grid1[2]?.LEADTIME, grid1[2]?.RETEXP, grid1[2]?.QUANTITY, grid1[2]?.COST, grid1[2]?.COMMENTS],
              ['', grid1[3]?.COMPONENT, grid1[3]?.DESCRIPTION, grid1[3]?.MANUFACTURER, grid1[3]?.MATERIAL, grid1[3]?.PKGCODE, grid1[3]?.LEADTIME, grid1[3]?.RETEXP, grid1[3]?.QUANTITY, grid1[3]?.COST, grid1[3]?.COMMENTS],
              ['', grid1[4]?.COMPONENT, grid1[4]?.DESCRIPTION, grid1[4]?.MANUFACTURER, grid1[4]?.MATERIAL, grid1[4]?.PKGCODE, grid1[4]?.LEADTIME, grid1[4]?.RETEXP, grid1[4]?.QUANTITY, grid1[4]?.COST, grid1[4]?.COMMENTS],
              ['', grid1[5]?.COMPONENT, grid1[5]?.DESCRIPTION, grid1[5]?.MANUFACTURER, grid1[5]?.MATERIAL, grid1[5]?.PKGCODE, grid1[5]?.LEADTIME, grid1[5]?.RETEXP, grid1[5]?.QUANTITY, grid1[5]?.COST, grid1[5]?.COMMENTS],
              ['', grid1[6]?.COMPONENT, grid1[6]?.DESCRIPTION, grid1[6]?.MANUFACTURER, grid1[6]?.MATERIAL, grid1[6]?.PKGCODE, grid1[6]?.LEADTIME, grid1[6]?.RETEXP, grid1[6]?.QUANTITY, grid1[6]?.COST, grid1[6]?.COMMENTS],
              ['', grid1[7]?.COMPONENT, grid1[7]?.DESCRIPTION, grid1[7]?.MANUFACTURER, grid1[7]?.MATERIAL, grid1[7]?.PKGCODE, grid1[7]?.LEADTIME, grid1[7]?.RETEXP, grid1[7]?.QUANTITY, grid1[7]?.COST, grid1[7]?.COMMENTS],
            ],
          },
        },
        {
          margin: [0, 10, 0, 0],
          style: 'table1',
          table: {
            widths: [4, '*', 50, 50, 50, 0, '*', 50, 0, '*', 50],
            body: [
              [{ text: 'PACKAGE DATA', rowSpan: 7, style: 'yellow' }, { text: 'COMPONENT', style: 'blue' }, { text: 'LENGTH(mm)', style: 'blue' }, { text: 'WIDTH(mm)', style: 'blue' }, { text: 'HEIGHT(mm)', style: 'blue' }, { text: '', border: [] }, { text: 'COMPONENT', style: 'blue' }, { text: 'WEIGHT(kg)', style: 'blue' }, { text: '', border: [] }, { text: 'QUANTITIES', style: 'blue' }, { text: '', style: 'blue' }],
              ['', grid2[0]?.COMPONENT, grid2[0]?.LENGTH, grid2[0]?.WIDTH, grid2[0]?.HEIGHT, { text: '', border: [] }, grid2[0]?.COMPONENT2, grid2[0]?.WEIGHT, { text: '', border: [] }, grid2[0]?.QUANTITIES, grid2[0]?.QUANTITIES2],
              ['', grid2[1]?.COMPONENT, grid2[1]?.LENGTH, grid2[1]?.WIDTH, grid2[1]?.HEIGHT, { text: '', border: [] }, grid2[1]?.COMPONENT2, grid2[1]?.WEIGHT, { text: '', border: [] }, grid2[1]?.QUANTITIES, grid2[1]?.QUANTITIES2],
              ['', grid2[2]?.COMPONENT, grid2[2]?.LENGTH, grid2[2]?.WIDTH, grid2[2]?.HEIGHT, { text: '', border: [] }, grid2[2]?.COMPONENT2, grid2[2]?.WEIGHT, { text: '', border: [] }, grid2[2]?.QUANTITIES, grid2[2]?.QUANTITIES2],
              ['', grid2[3]?.COMPONENT, grid2[3]?.LENGTH, grid2[3]?.WIDTH, grid2[3]?.HEIGHT, { text: '', border: [] }, grid2[3]?.COMPONENT2, grid2[3]?.WEIGHT, { text: '', border: [] }, grid2[3]?.QUANTITIES, grid2[3]?.QUANTITIES2],
              ['', grid2[4]?.COMPONENT, grid2[4]?.LENGTH, grid2[4]?.WIDTH, grid2[4]?.HEIGHT, { text: '', border: [] }, grid2[4]?.COMPONENT2, grid2[4]?.WEIGHT, { text: '', border: [] }, grid2[4]?.QUANTITIES, grid2[4]?.QUANTITIES2],
              ['', grid2[5]?.COMPONENT, grid2[5]?.LENGTH, grid2[5]?.WIDTH, grid2[5]?.HEIGHT, { text: '', border: [] }, grid2[5]?.COMPONENT2, grid2[5]?.WEIGHT, { text: '', border: [] }, grid2[5]?.QUANTITIES, grid2[5]?.QUANTITIES2],
            ],
          },
        },
        {
          style: 'table1',
          layout: {
            fillColor: '#f4f0df',
            hLineWidth: function (_i: any, _node: any) {
              return 0;
            },
            vLineWidth: function (_i: any, _node: any) {
              return 0;
            }
          },
          table: {
            widths: ['*', '*', '*', '*'],
            body: [
              [`Supplier Signature : ${this.converNull(ppfData.SUPPLIERCONTACT)}`, '', `Date : ${ppfData.SUPPLIERDATE && this.getDateFormat(new Date(ppfData.SUPPLIERDATE).toISOString().slice(0, 10))}`, `Please indicate other affiliate this part/pkg is shipped to: ${this.converNull(ppfData?.AFFILIATE)}`],
              [`Toyota Approval Signature: ${this.converNull(ppfData?.APPROVER)}`, `Approved : ${ppfData.APPROVER ? 'Yes' : 'No'}`, `Date : ${ppfData.APPROVEDATE && this.getDateFormat(new Date(ppfData.APPROVEDATE).toISOString().slice(0, 10))}`, `Comments : ${this.converNull(ppfData.NOTE)}`],
            ],
          },
        },
      ],
      styles: {
        table1: {
          fontSize: 7,
        },
        blue: {
          fillColor: '#e4ecf0',
        },
        yellow: {
          fillColor: '#f4f0df',
        },
        header1: {
          fontSize: 13,
        },
        header2: {
          fontSize: 8,
          bold: true
        },
        part: {
          fontSize: 11,
          bold: true
        }
      },

    }
  }


  ngOnDestroy(): void {
    this.userInfoSubscriber?.unsubscribe();
  }
}
